import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: { addTaxResidency: 'Declare another tax domicile' },
  fr: { addTaxResidency: 'Déclarer un autre domicile fiscal' },
} as const);

export default locales;
